/* eslint-disable no-param-reassign, no-restricted-syntax */
import { ColumnElement, ColumnItemElement } from '@typedream/core';
import {
  getNodeChildren,
  isElementEmpty,
  removeNodes,
  setElements,
  TNodeEntry,
  withoutNormalizing,
  wrapNodes,
} from '@udecode/plate-core';
import { DreamEditor } from '../../../types';

export const normalizeColumn = (
  editor: DreamEditor,
  entry: TNodeEntry<ColumnElement>,
) => {
  const [node, path] = entry;

  /**
   * remove empty column
   */
  if (isElementEmpty(editor, node)) {
    removeNodes(editor, { at: path });
    return true;
  }

  /**
   * wrap non column_item child with column_item
   */
  for (let i = 0; i < node.children.length; i++) {
    const child = node.children[i];
    const childPath = [...path, i];

    if (child.type !== 'column_item') {
      wrapNodes(
        editor,
        {
          type: 'column_item',
          children: [],
          width: parseFloat((1 / node.children.length).toFixed(5)),
        },
        { at: childPath },
      );
      return true;
    }
  }

  /**
   * fix children width if they don't sum up to 1
   */
  if (!node.align || node.align === 'column_dynamic') {
    let sumOfWidth = 0;

    for (const child of node.children) {
      if (Number.isFinite(child.width) && child.width > 0) {
        sumOfWidth += child.width;
      } else {
        sumOfWidth += 1 / node.children.length;
      }
    }

    if (sumOfWidth < 0.99 || sumOfWidth > 1.01) {
      withoutNormalizing(editor, () => {
        const childrenEntries = getNodeChildren<ColumnItemElement>(editor, path);
        for (const [child, childPath] of Array.from(childrenEntries)) {
          const childWidth = Number.isFinite(child.width) && child.width > 0
            ? child.width
            : 1 / node.children.length;

          setElements(
            editor,
            { width: parseFloat((childWidth / sumOfWidth).toFixed(5)) },
            { at: childPath },
          );
        }
      });

      return true;
    }
  }

  return undefined;
};
